import React, { useEffect, useCallback, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import Connect from "../../../shared/redux/Connect.hoc";
import ServiciosTable from "../Tables/Servicios.table";
import "./styles.scss";
import { createNotification, validateArray, presentconfirmAlert } from '../../../utils/utils'
import {getServices} from '../../../helpers/Servicios.helper';

const ListServicios = ({ history,state }) => {

const [data, setData] = useState();

    const getData = async()=>{
        const data = await getServices(state.auth.user._id);
        if (data['code'] === 400){
            createNotification('Error al cargar los servicios del cliente','error');

        }else {
            setData(data['data']);



        }




      }

useEffect(()=>{
    getData()

},[])

  return (
    <>
      <div className="col-9">
        <div className="row mt-3">
        <h2  style={{fontFamily: " Montserrat", color:'#2994CD', textAlign:'left', position:'relative', left:'25px' }}>Mis Servicios</h2>
          <div className="col">
            <ServiciosTable
            history = {history}
             dataServicios = {data}
             
            />
          </div>
        </div>
     
      </div>
    </>
  );
};

export default withRouter(Connect(ListServicios));
